import { FC, ReactNode } from 'react';

type TableProps = {
  className?: string;
  content: ReactNode;
};

const Table: FC<TableProps> = ({ className, content }) => (
  <table className={className || 'table table-striped'}>{content}</table>
);

export default Table;
